import { Container, StringHelper } from "@bryntum/schedulerpro";
import { exportDataApi } from "../../../network/network.jsx";
import { serverErrorMsg, showToast } from "../../../other/utils/utils.jsx";
import { IMPORT_TYPES } from "../../../other/constants/OtherKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { shouldShowAsyncDialog } from "../AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";

export default class DownloadTab extends Container {
  static get $name() {
    return "DownloadTab";
  }

  static get type() {
    return "downloadtab";
  }

  static get configurable() {
    return {
      title: "Export",
      items: [
        {
          ref: "archiveCheckbox",
          type: "checkbox",
          text: "Include Archived Records",
          hidden: true,
          cls: "[&_div.b-field-inner]:justify-center",
          onChange: "up.onArchivedCheckChange"
        },
        {
          ref: "downloadButton",
          type: "button",
          cls: "b-raised b-blue",
          onAction: "up.onDownload",
        },
        {
          ref: "budgetDownloadButton",
          type: "button",
          cls: "b-raised b-blue",
          menu: {
            items: [
              { text: "Export editable fields", onItem: "up.onDownload", exportType: "template" },
              { text: "Export all fields", onItem: "up.onDownload", exportType: "complete" }
            ]
          },
          hidden: true
        }
      ]
    };
  }

  onDownload({ item = null }) {
    const { importType } = this.record;
    const {archiveCheckbox  } = this.widgetMap;
    const selectedBoardSlug = this.context.selectedBoard.record.slug;
    let updatedImportType = importType, params;
    if (updatedImportType === IMPORT_TYPES.boardUsers) {
      updatedImportType = "Board Users";
    } else if (item) {
      params = { export_type: item.exportType }
    }

    if (!archiveCheckbox.hidden) {
      params = { ...params, include_archived: archiveCheckbox.value }
    }

    // Show user feedback dialog with 'Don't show again' option
    const showDialog = shouldShowAsyncDialog('CSV_EXPORT');
    showDialog && this.context.editorHandler.openEditor(EDITOR_KEYS.asyncTaskMessageEditor, null, {record: "CSV_EXPORT"}, { useExisting: true, by: "recordType" });

    this.mask("Exporting...");
    exportDataApi(selectedBoardSlug, importType, params).catch((error) => { if (error.response) showToast({ msg: serverErrorMsg(), type: "error" }); }).finally(() => {
      this.unmask();
    })
  }

  editRecord(record, context, otherParams) {
    this.record = record;
    this.context = context;

    const { downloadButton, budgetDownloadButton, archiveCheckbox  } = this.widgetMap;
    if (otherParams.isEntityArchive) {
      archiveCheckbox.hidden = false;
    }
    let updatedImportType = record.importType;
    if (updatedImportType === IMPORT_TYPES.boardUsers) {
      updatedImportType = "Board Users";
    } else if (updatedImportType === IMPORT_TYPES.taskBudget) {
      budgetDownloadButton.text = `Export ${StringHelper.capitalize(updatedImportType)} (CSV)`
      downloadButton.hidden = true;
      budgetDownloadButton.hidden = false;
    }
    downloadButton.text = `Export ${StringHelper.capitalize(updatedImportType)} (CSV)`;
  }
}

DownloadTab.initClass();
